
import Lock from 'rde-view-common/components/common/lock/Lock';
import Footer from 'rde-view-common/components/layouts/Footer';
import Header from 'rde-view-common/components/layouts/Header';
import RdeCommonContents from 'rde-view-common/components/layouts/RdeCommonContents';
import MessageUtils from 'rde-view-common/scripts/messageUtils';

/**
 * デフォルトレイアウト
 */
export default {
  components: {
    Header,
    Lock,
    RdeCommonContents,
    Footer
  },
  data: () => {
    return {
      messages: []
    };
  },
  methods: {
    clear() {
      MessageUtils.clearMessage();
    }
  }
};
